import { Party } from '~/features/manage-parties/types';
import { pilot } from '~/services/serviceInstances';
import { PilotId } from '~/types/PilotId';

interface Request {
  clientId: PilotId;
  isInternal: boolean;
  oldName: string;
  party: Party;
}

export const updateParty = async ({
  clientId,
  isInternal,
  oldName,
  party,
}: Request): Promise<boolean> => {
  const params = {
    internal: isInternal,
    old_name: oldName,
    party,
  };

  await pilot.post(`client/${clientId}/update-party-list/`, params);

  return true;
};
